import config from 'config';
import { useQuery } from 'react-query';
import { useContext } from 'react';
import apiClient from '../../../helpers/apiClient';
import { useGameStore } from './useGameStore';
import GameCodeContext from '../../../containers/Games/GameCodeContext';

async function getSettings(gameCode) {
  useGameStore.getState().setBettingDisabled(true);
  let url = `/v1/${gameCode}/games/setting`;
  if (['bitto', 'ladder', 'turtle', 'baccarat'].includes(gameCode)) {
    url = `/${gameCode}/game/info`;
  }
  if (['cfBattle', 'blackjack'].includes(gameCode)) {
    url = `/v1/games/setting?game=${gameCode}`;
  }
  if (gameCode === 'baccarat') {
    url = '/v2/baccarat/games/current/setting';
  }
  return (await apiClient().get(url, { params: { asset: config.asset } })).data;
}
export default function useSettings(querySettings) {
  const gameCode = useContext(GameCodeContext);
  const { data: settings = {}, isLoading, isError } = useQuery(['settings', gameCode], () => getSettings(gameCode), {
    onSuccess: () => useGameStore.getState().setBettingDisabled(false),
    refetchOnMount: false,
    ...querySettings,
  });

  const {
    min_bet: minBet,
    max_bet: maxBet,
    max_payout: maxPayout,
    base_participate_balance: defaultBet,
    highroll_min_payout: highrollerMinimum,
    address,
    payout_rate: payoutRate,
    decimal_place: decimalPlaces,
    ...rest
  } = settings;
  return {
    isLoading: isLoading || isError,
    minBet,
    maxBet,
    maxPayout,
    defaultBet,
    highrollerMinimum,
    decimalPlaces,
    address,
    payoutRate,
    ...rest,
  };
}
